/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_LargestInputs */

const en_landing_why_largest = /** @type {(inputs: Landing_Why_LargestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largest edit shown`)
};

const zh_landing_why_largest = /** @type {(inputs: Landing_Why_LargestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大编辑示例`)
};

/**
* | output |
* | --- |
* | "Largest edit shown" |
*
* @param {Landing_Why_LargestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_largest = /** @type {((inputs?: Landing_Why_LargestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_LargestInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_largest(inputs)
	return zh_landing_why_largest(inputs)
});
export { landing_why_largest as "landing.why.largest" }